import jwt from '../../http/requests/auth/jwt/index.js';
import 'firebase/auth';

export default {

  addSupplier(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .saveHttpSupplier(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getSupplierList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpSupplierList(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getAllSupplierList() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpAllSupplierList()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getInstantSupplierList() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpAllInstantSupplierList()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getSupplierDetails(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpSupplierDetail(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateSupplierDetails(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .updateHttpSupplierDetail(data)
        .then((res) => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  },
  getSupplierProductList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpProductListBySupplier(data.dataTableParams, data.id)
        .then((res) => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  },
  removeSupplierFromProduct(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .deleteHttpProductFromSupplier(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getSupplierOrderList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpOrderListBySupplier(data.dataTableParams, data.id)
        .then((res) => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  },
  getOrderDetails(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpOrderDetailForSupplier(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  searchNearbyClinics(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpsearchNearbyClinics(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getRelatedSuppliers(_context, supplierId) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpRelatedSuppliers(supplierId)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
};
